import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const Access = (props) => {
  const handleBeneficiaries = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          roads_railways_bridges: Number(value),
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>8.4</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Доступи (дороги, залізниці, мости)"
      titleEN="Access (roads, railways, bridges)"
      children={(
        <div className="flex-group">
          <input
            placeholder="0"
            id="roads_railways_bridges"
            className="number"
            name="roads_railways_bridges"
            value={props.formData.info.landuse_and_beneficiaries.roads_railways_bridges}
            autoComplete="off"
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              const total = props.checkPercent('roads_railways_bridges') + newValue;
              if (total <= 100) {
                handleBeneficiaries(newValue);
              } else {
                e.preventDefault();
              }
            }}
          />
          <span>%</span>
        </div>
      )}
    />
  );
};
